<template>
  <div class="flex items-center relative">
    <PVIconField>
      <PVInputIcon>
        <Search class="stroke-secondary-600" :size="16" />
      </PVInputIcon>
      <PVInputText class="px-7" v-bind="$attrs" />
      <PVInputIcon>
        <PVButton
          v-if="$attrs.modelValue"
          text
          rounded
          class="!p-2 !m-0 focus:ring-0"
          @click="$emit('resetSearch')">
          <template #icon>
            <X :size="16" />
          </template>
        </PVButton>
      </PVInputIcon>
    </PVIconField>
  </div>
</template>

<script setup lang="ts">
import { Search } from 'lucide-vue-next';
import type { InputStyle } from './InputPreset';
import type { PropType } from 'vue';
import { X } from 'lucide-vue-next';

import PVButton from 'primevue/button';
import PVIconField from 'primevue/iconfield';
import PVInputIcon from 'primevue/inputicon';
import PVInputText from 'primevue/inputtext';

defineEmits(['resetSearch']);
defineProps({
  rounded: Boolean,
  full: {
    type: Boolean,
    default: false,
  },
  style: {
    type: String as PropType<InputStyle>,
    default: 'white',
  },
});
</script>
